// @TODO: fine-tune copy
// @TODO: put in landing pages dir?
/*
 * Ryan O'Dowd
 * 2022-07-22
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
// @TODO: tiny partner images
import React, {
  useEffect,
} from 'react';
import {
  Card, // @TODO: create wrapper for this in common
} from 'react-native-paper';
import ContactForm from '@website/components/ContactForm';
import DownloadLinks from '@website/components/DownloadLinks';
import PricingMatrix from '@website/components/PricingMatrix';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import WebPageStub from '@website/containers/WebPageStub';
import WebsiteSection from '@website/components/WebsiteSection';
import {
  fetchOrganizations,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

const Fundraising = () => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();

  const organizations = hooks.useTypedSelector((state) => state.organizations);

  useEffect(() => {
    dispatch(fetchOrganizations());
  }, [dispatch]);

  const _renderBulletPoint = (title, body, lightBackground = false) => {
    return <Text style={[styles.bulletPoint, lightBackground && styles.lightBackgroundText]}><Text style={[styles.title, lightBackground && styles.lightBackground]}>{title}</Text>{body}</Text>;
  };

  const _renderOrganization = (organization) => { // @TODO: make this its own component
    return (
      <Card style={styles.organizationCard}>
        <Card.Cover
          style={styles.cardMedia}// @TODO: move into wrapper component in common
          source={{uri: organization.logo_url}}
          resizeMode='contain'
          // @TODO: onpress: to={`/organizations/${organization.slug}`}
        />
        <Card.Content style={styles.cardContent}>
          <Text style={styles.organizationName}>{organization.name}</Text>
          <Text style={styles.organizationText}>{organization.description}</Text>
        </Card.Content>
        <Card.Actions>
          {null/* @TODO: there's nothing in actions, but i want the rborder radius */}
        </Card.Actions>
      </Card>
    );
  };

  return (
    <WebPageStub>
      <WebsiteSection
        isDarkBackground={true}
        title='Fundraising with purpose'
      >
        <Text style={styles.heroText}>{"Wrinkly is ideal for summer camps, missions trips, youth groups, schools, and any other group that is raising funds for events, travel, or other missional activities.  It's incredibly rewarding to help Christ-centered organizations to raise money, to provide a way for sponsors to feel involved, and to watch participants spend more time in Scripture.  We love supporting these types of organizations and would love for you to join us!"}</Text>
        <Text style={styles.heroText}>Join Wrinkly today as an organization, sponsor, or participant.</Text>
      </WebsiteSection>

      <WebsiteSection
        title='For organizations'
      >{/* @TODO: make sure this looks good on mobile */}
        <View style={styles.inner}>
          <View style={styles.sideBySide}>
            <View style={styles.section}>
              {/* @TODO: hash anchor link
              {_renderBulletPoint('Apply', <>Use <a href='#contact'>the form below to contact us</a>{" with information about your organization, and we'll establish your account and get your first campaign started."}<>)}
              */}
              {_renderBulletPoint('Apply', "Use the form here to contact us with information about your organization, and we'll establish your account and get your first campaign started.", true)}
              {_renderBulletPoint('Track', "Get insights into participant progress, sponsors' pledges, and campaign efficacy.", true)}
              {_renderBulletPoint('Sit back', "Wrinkly handles all of the tracking, invoicing, and payments so you don't have to.", true)}
              {_renderBulletPoint('Earn', 'At the end of the campaign, you will receive a check with the proceeds.', true)}
              {/* @TODO: something about feeling good about the impact as well */}
            </View>
            <View style={styles.section}>
              <span style={styles.contactHeader}>Enroll your organization</span>
              <ContactForm
                leadingText='Please include a brief description of your organization, the campaign you are planning, and a link to your website if you have one.'
                textStyles={styles.contactText}
              />{/* @TODO: make more fields for the info I'm looking for instead of just telling them what to include in the body of the message */}
            </View>
          </View>
        </View>
      </WebsiteSection>

      <WebsiteSection
        isDarkBackground={true}
        title='For sponsors'
      >
        <View style={styles.section}>
          {_renderBulletPoint('Pick an origanization', 'Summer camps, church groups, schools, and other groups are looking for sponsors.')}
          {_renderBulletPoint('Determine a pledge amount', 'Pick an amount to donate per verse memorized up to a specified threshold.')}
          {_renderBulletPoint('Donate with confidence', 'Wrinkly uses many techniques to make learning easier and to help memorized verses stick for a long time.  You can be certain that your donation is going to a good cause and that participants are spending meaningful time in the Word.')}
          {_renderBulletPoint('Receive a report with your impact', "At the end of the campaign, you will receive a report detailing participants' achievements and your impact for the organization.")}
        </View>
      </WebsiteSection>

      <WebsiteSection
        title='For participants'
      >
        <View style={styles.section}>
          {_renderBulletPoint('Join an origanization.', 'Accept an invitation from your group organizer.', true)}
          {_renderBulletPoint('Use Wrinkly to learn Bible verses.', 'Each verse memorized during the campaign will earn money for your organization.', true)}
        </View>
      </WebsiteSection>

      {!!Object.values(organizations).filter((o: any) => o.is_public).length &&
        <WebsiteSection
          isDarkBackground={true}
          title='Partners'
        >
          <View>{/* @TODO: add flexwrap styles */}
            {Object.values(organizations).filter((o: any) => o.is_public).reverse().map((o: any) => { // @TODO: order by most recent campaign to least recent
              return (
                <View key={o.id}>
                  {_renderOrganization(o)}
                </View>
              );
            })}
          </View>
        </WebsiteSection>
      }

      <WebsiteSection
        title='Contact us'
      >
        <View style={styles.contactAndDownloadWrapper}>
          <View style={styles.contactWrapper}>
            <ContactForm leadingText="If you are an organization, sponsor, or participant interested in Wrinkly, we'd love to hear from you." />
          </View>
          <View style={styles.downloadCtaWrapper}>
            <h2>Download now</h2>
            <View style={styles.downloadLinks}>
              <DownloadLinks />
            </View>
          </View>
        </View>
      </WebsiteSection>

      <WebsiteSection title='Pricing'>
        <PricingMatrix />
      </WebsiteSection>

    </WebPageStub>
  );
};

export default Fundraising;
